import React, { useEffect } from "react";
import { navigate, RouteComponentProps } from "@reach/router";
import {
  Avatar,
  Box,
  Container,
  styled,
  TextField,
  Typography
} from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';


import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { useAppDispatch, useAppSelector } from "../hooks/redux";
import { actions } from '../services/auth';
import { AdminRole } from "../types/auth";

const Root = styled('div')({

});

const LoginPage: React.FC<RouteComponentProps> = () => {

  const auth = useAppSelector(state => state.auth);
  const dispatch = useAppDispatch();

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const email = data.get('email') as string;
    const pass = data.get('password') as string;


    dispatch(actions.login(email, pass));
  };

  useEffect(() => {
    if (auth.user?.roles.includes(AdminRole.admin)) {
      navigate('/', { replace: true });
    }
  }, [ auth.user ]);


  return (
    <Root>
      <Container component="main" maxWidth="xs">
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5" paragraph>
            Sign in
          </Typography>

          <Typography color="error" style={{ visibility: Boolean(auth.error) ? 'visible' : 'hidden' }}>
            Invalid credentials
          </Typography>
          <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
            />

            <LoadingButton
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              loading={auth.signInLoading}
            >
              Sign In
            </LoadingButton>
          </Box>
        </Box>
      </Container>
    </Root>
  );
};

export default LoginPage;